if (process.env.NODE_ENV !== 'production') {
  require('./index.html');
  require('./styles.css');
}

//Load Site Assets
// require('aframe');
require('aframe-troika-text');
//require('aframe-slice9-component');

require('./query-string.js');
require('./gui-env.js');
require('./helpers.js');

require('./btn.js');
require('./pin.js');
require('./marker.js');
require('./enter-site.js');
require('./open-modal.js');
//require('./modal.js');

require('./navigate.js');
require('./menu.js');

//require('./tts.js');

require('./responsivevoice.js');

//(function () {
document.addEventListener('DOMContentLoaded', function() {

    const earth = document.getElementById('earth');
    const globe = document.getElementById('globe');
    const wa_layer = document.getElementById('wa_layer');
    const wa_btn = document.getElementById('wa_btn');
    const pin_layer = document.getElementById('pin_layer');

    const info = document.getElementById('info');
    const project_title = document.getElementById('project_title');
    const region_details = document.getElementById('region_details');
    const ecosystem_details = document.getElementById('ecosystem_details');
    const eco_panel_slide1 = document.getElementById('eco_panel_slide1');
    const eco_panel_slide2 = document.getElementById('eco_panel_slide2');
    const eco_panel_slide3 = document.getElementById('eco_panel_slide3');
    const eco_panel_slide4 = document.getElementById('eco_panel_slide4');
    const eco_panel_indicate1 = document.getElementById('eco_panel_indicate1');
    const eco_panel_indicate2 = document.getElementById('eco_panel_indicate2');
    const eco_panel_indicate3 = document.getElementById('eco_panel_indicate3');
    const eco_panel_indicate4 = document.getElementById('eco_panel_indicate4');

    const btnTTSEco = document.getElementById('btnTTSEco');


    const site_video = document.getElementById('site');
    const nav_siteA =  document.getElementById('nav_site-a');


// helper functions
    function showEl(el){
      el.setAttribute('visible','true');
      el.setAttribute('scale','1 1 1');
    }
    function hideEl(el){
      el.setAttribute('visible','false');
      el.setAttribute('scale','0.00001 0.00001 0.00001');
    }

    function resetEcoPanel(){
      eco_panel_slide1.setAttribute('visible',true);
      eco_panel_indicate1.setAttribute('visible',true);

      eco_panel_slide2.setAttribute('visible',false);
      eco_panel_indicate2.setAttribute('visible',false);
      eco_panel_slide3.setAttribute('visible',false);
      eco_panel_indicate3.setAttribute('visible',false);
      eco_panel_slide4.setAttribute('visible',false);
      eco_panel_indicate4.setAttribute('visible',false);
    }

//triggered functions
    window.btnActionEarth = function() {
      console.log("btnActionEarth");
      view_earth();
      showEl(project_title);
      hideEl(region_details);
      hideEl(ecosystem_details);
    }

    window.btnActionRegion = function() {
      console.log("btnActionRegion");
      closeup_region();
      hideEl(project_title);
      showEl(region_details);
      hideEl(ecosystem_details);
      //queryString.push('region', "washington"); // query-string library
    }



    window.pinSelection = function() {
      console.log("pinSelection ecosystem");
      hideEl(project_title);
      hideEl(region_details);
      showEl(ecosystem_details);  
      resetEcoPanel();    
      //queryString.push('ecosystem', "north-pacific-seasonal-sitka-spruce-forest"); // query-string library      
    }


    window.btnActionEcoDesc = function() {
      resetEcoPanel();
      btnTTSEco.setAttribute('btn','clickAction:btnTTSEcoDesc');      
    }
    window.btnActionEcoCons = function() {
      eco_panel_slide2.setAttribute('visible',true);
      eco_panel_indicate2.setAttribute('visible',true);

      eco_panel_slide1.setAttribute('visible',false);
      eco_panel_indicate1.setAttribute('visible',false);
      eco_panel_slide3.setAttribute('visible',false);
      eco_panel_indicate3.setAttribute('visible',false);
      eco_panel_slide4.setAttribute('visible',false);
      eco_panel_indicate4.setAttribute('visible',false);

      btnTTSEco.setAttribute('btn','clickAction:btnTTSEcoCons');      
    }
    window.btnActionEcoDist = function() {
      eco_panel_slide3.setAttribute('visible',true);
      eco_panel_indicate3.setAttribute('visible',true);

      eco_panel_slide1.setAttribute('visible',false);
      eco_panel_indicate1.setAttribute('visible',false);
      eco_panel_slide2.setAttribute('visible',false);
      eco_panel_indicate2.setAttribute('visible',false);
      eco_panel_slide4.setAttribute('visible',false);
      eco_panel_indicate4.setAttribute('visible',false);

      btnTTSEco.setAttribute('btn','clickAction:btnTTSEcoDist');      
    }
    window.btnActionEcoEnv = function() {
      eco_panel_slide4.setAttribute('visible',true);
      eco_panel_indicate4.setAttribute('visible',true);

      eco_panel_slide1.setAttribute('visible',false);
      eco_panel_indicate1.setAttribute('visible',false);
      eco_panel_slide2.setAttribute('visible',false);
      eco_panel_indicate2.setAttribute('visible',false);
      eco_panel_slide3.setAttribute('visible',false);
      eco_panel_indicate3.setAttribute('visible',false);

      btnTTSEco.setAttribute('btn','clickAction:btnTTSEcoEnv');      
    }


    window.btnActionVisit = function() {
      var floor = document.getElementById('floor');
      hideEl(floor);

      console.log("btnActionVisit");
      hideEl(info);      
      hideEl(earth);
      showEl(site_video);
      showEl(nav_siteA);
      //queryString.push('location', "site-a"); // query-string library

      var videoEl = document.querySelector('#site-a');
      videoEl.currentTime = 0;  // Seek to 122 seconds.
      videoEl.play();

      var infoModal = document.getElementById('infomodal');
      showEl(infoModal);

    
// // to set specific time of video
// document.querySelector("#site-a").components.material.data.src.currentTime = 0 // start of video
// // to play the videosphere
// document.querySelector("#site-a").components.material.material.map.image.play();

    }


    window.btnCloseModal = function() {
      var modalWrapper = document.getElementById('modal-wrapper');
      var modalImg = document.getElementById('modalimg');
      hideEl(modalImg);
      hideEl(modalWrapper);
    }


    window.btnShowInfo = function() {
      var infoModal = document.getElementById('infomodal');
      showEl(infoModal);
    }

    window.btnCloseInfo = function() {
      var infoModal = document.getElementById('infomodal');
      hideEl(infoModal);
    }


//initial earth position
    function view_earth() {
      earth.removeAttribute('animation__rotate_in');
      earth.removeAttribute('animation__move_in');

      globe.removeAttribute('animation__fade_out');
      wa_layer.removeAttribute('animation__fade_in');
      wa_btn.removeAttribute('animation__dive_out');

      earth.setAttribute('animation__rotate_out', `property: rotation; to:0 0 0; dur:1500;`);
      earth.setAttribute('animation__move_out', `property: position; to: 0 -10 -30; dur:1500;`);

      globe.setAttribute('animation__fade_in', `property: material.color; from:#878DA1; to: #ffffff; dur:1500;`);
      wa_layer.setAttribute('animation__fade_out', `property: material.opacity; from:1; to: 0; dur:1500;`);
      wa_btn.setAttribute('animation__dive_in', `property: position; from:0 0 0; to: 0 19.75 0; dur:1500;`);
      hideEl(pin_layer);

    }
//zoomed into /region: e.g. WA state
    function closeup_region() {
      earth.removeAttribute('animation__move_out');
      earth.removeAttribute('animation__rotate_out');

      globe.removeAttribute('animation__fade_in');
      wa_layer.removeAttribute('animation__fade_out');
      wa_btn.removeAttribute('animation__dive_in');

      earth.setAttribute('animation__rotate_in', `property: rotation; to:10 30 0; dur:1500;`);
      earth.setAttribute('animation__move_in', `property: position; to:0 -10.85 -17.25; dur:1500;`);

      globe.setAttribute('animation__fade_out', `property: material.color; from:#ffffff; to: #878DA1; dur:1500;`);
      wa_layer.setAttribute('animation__fade_in', `property: material.opacity; from: 0; to:1; dur:1500;`);
      wa_btn.setAttribute('animation__dive_out', `property: position; from: 0 19.75 0; to:0 0 0; dur:1500;`);
      showEl(pin_layer);

    }


});
//  })();




//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 6
// module chunks = 0